import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { MessageResponse } from '../../shared/models/message-response.model';

import { WalletCreateDto } from './dtos/wallet-create';
import { WalletDeleteDto } from './dtos/wallet-delete';
import { WalletUpdateDto } from './dtos/wallet-update';

@Injectable({
	providedIn: 'root',
})
export class WalletsService {
	private readonly endpoint: string = `${environment.apiUrl}/wallets`;

	constructor(private readonly http: HttpClient) {}

	createManyWallets({
		dto,
	}: {
		dto: WalletCreateDto[];
	}): Observable<MessageResponse> {
		return this.http.post<MessageResponse>(`${this.endpoint}/bulk`, {
			wallets: dto,
		});
	}

	createWallet({ dto }: { dto: WalletCreateDto }): Observable<MessageResponse> {
		return this.http.post<MessageResponse>(`${this.endpoint}`, dto);
	}

	deleteOneWallet({
		dto,
	}: {
		dto: WalletDeleteDto;
	}): Observable<MessageResponse> {
		const params = new HttpParams()
			.set('walletId', dto.walletId)
			.set('deletedInInsuranceAt', dto.deletedInInsuranceAt);

		return this.http.delete<MessageResponse>(`${this.endpoint}`, {
			params,
		});
	}

	updateManyWallets({
		dto,
	}: {
		dto: WalletUpdateDto[];
	}): Observable<MessageResponse> {
		return this.http.patch<MessageResponse>(`${this.endpoint}/benefits/bulk`, {
			wallets: dto,
		});
	}
}
